import { render, staticRenderFns } from "./natureUser.vue?vue&type=template&id=185e9a38&scoped=true"
import script from "./natureUser.vue?vue&type=script&lang=js"
export * from "./natureUser.vue?vue&type=script&lang=js"
import style0 from "./natureUser.vue?vue&type=style&index=0&id=185e9a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e9a38",
  null
  
)

export default component.exports